import {SidebarCollapseIcon, SidebarExpandIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {useRef} from 'react'

import {DockedPanel, useDockedPanelActions, useIsDockedPanelOpen, useLastPanel} from '../../contexts/DockedPanelContext'
import {usePullRequestAnalytics} from '../../hooks/use-pull-request-analytics'

export function OpenDockedPanelButton({size = 'small'}: {size?: 'small' | 'medium'}) {
  const isPanelOpen = useIsDockedPanelOpen()
  const actions = useDockedPanelActions()
  const buttonRef = useRef<HTMLButtonElement>(null)
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()
  const lastPanel = useLastPanel()

  const defaultPanel = lastPanel ?? DockedPanel.Overview

  const ariaLabel = isPanelOpen ? 'Close panel' : 'Open panel'

  return (
    <IconButton
      ref={buttonRef}
      aria-label={ariaLabel}
      aria-expanded={isPanelOpen}
      icon={isPanelOpen ? SidebarCollapseIcon : SidebarExpandIcon}
      size={size}
      variant="default"
      onClick={() => {
        sendPullRequestAnalyticsEvent('panel_button_group.toggle_panel', 'PANEL_BUTTON_GROUP')
        if (isPanelOpen) {
          actions.closePanel()
        } else {
          actions.openPanel(defaultPanel, {returnFocusTo: buttonRef.current})
        }
      }}
    />
  )
}
